import React from "react";
import {Button} from "@material-ui/core";

const RegenerateBio = ({show, onRegenerate, classes, ...props}) => {
    return <>
        { (show) &&
            <Button
                variant="outlined"
                classes={classes}
                onClick={onRegenerate}
            >
                Regenerate Bio
            </Button>
        }
    </>
}

export default RegenerateBio;